import { Component, Host, h, Prop, Element } from '@stencil/core';
import { toKebabCase } from '@utils/utils';

@Component({
  tag: 'generic-container',
  shadow: false,
})
export class GenericContainer {
  /**
   * @shortDescription Takes stringified json
   */
  @Prop() datajson: string;
  /**
   * @shortDescription Takes stringified json
   */
  @Prop() componentnamex: string;
  /**
   * @shortDescription Takes boolean check value to tell stringified json is base64 uri encoded
   */
  @Prop() isEncoded: boolean = false;

  @Element() private element: HTMLGenericContainerElement;

  private propString: string = '';
  private jsonObject: any;

  componentWillLoad() {
    this.jsonObject = this.datajson;
    if (this.isEncoded) {
      // START GENAI@GHCOPILOT
      this.datajson = this.datajson.replace(/\+/g, ' ');
      // END GENAI@GHCOPILOT
      const uriDecoded = decodeURIComponent(this.datajson);
      this.jsonObject = uriDecoded;
    }
  }

  // START GENAI@CHATGPT4
  private renderComp() {
    const jsonData = JSON.parse(this.jsonObject);
    Object.keys(jsonData).forEach(propName => {
      if (jsonData[propName]) {
        if (typeof jsonData[propName] === 'object') {
          let jsonString = JSON.stringify(jsonData[propName]).replace(/'/g, '&apos;');
          this.propString += `${toKebabCase(propName)}='${jsonString}' `;
        } else {
          let valueString = jsonData[propName].replace(/'/g, '&apos;');
          this.propString += `${toKebabCase(propName)}='${valueString}' `;
        }
      }
    });
    this.propString = `<${this.componentnamex} ${this.propString}></${this.componentnamex}>`;
    this.element.innerHTML = this.propString.toString();
  }
  // END GENAI@CHATGPT4

  render() {
    return <Host>{this.renderComp()}</Host>;
  }
}
